<template>
    <transition name="fade">
        <div class="modal" :class="{'show':modal_show}" tabindex="-1" aria-hidden="true" v-if="modal_show">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add Announcement</h5>
                        <button type="button" class="btn btn-round close" @click="close">
                            <i class="mdi mdi-close"></i>
                        </button>
                    </div>
                    <div class="modal-body p-0">
                        <vue-editor :editor-toolbar="customToolbar" v-model="data" ref="content"></vue-editor>
                    </div>
                    <div class="modal-footer">
                        <jl-button type="button" class="btn text-primary" :eventClick="addAnnouncement">Add</jl-button>
                        <button type="button" class="btn" @click="close">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { VueEditor } from "vue3-editor";

export default {
    components: {
        VueEditor,
    },
    data() {
        return {
            customToolbar: [
                ["bold", "italic", "underline", "strike"],
                [ 'link' ],
                [ 'img' ],
            ],
            modal_show: false,
            data: ''
        }
    },
    methods: {
        close() {
            this.modal_show = false;
            this.data = '';
        },
        async addAnnouncement(e) {
            await this.$axios.post('/announcements', this.$qs.stringify({data:this.data}))
                    .then((res) => {
                        if(res.status == 200) this.$emitter.emit('load_announcement');
                        this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
            this.close();
            this.$jlbutton.unload(e);
        },
        selectImage() {
            const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');
                input.click();

            input.onchange = async () => {
                const file = input.files[0];
                // file type is only image.
                if (/^image\//.test(file.type)) {
                    let toBase64 = await this.convert(file).catch(e => Error(e));
                    if(toBase64 instanceof Error) {
                        this.$jlalert.show(toBase64.message);
                        return;
                    }

                    this.saveFile('img', toBase64, (data) => {
                        let iframe = document.createElement('img');
                        iframe.setAttribute('src', data);
                        iframe.setAttribute('class', 'ql-img');

                        let content= this.$refs.content.$el;
                        let container = content.querySelector('.ql-editor');
                        container.appendChild(iframe);

                    });
                } else {
                    this.$jlalert.show('File type not allowed');
                }
            };
        },
        convert(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async saveFile(type, file, fn) {
            this.loading = true;
            await this.$axios.post(`/upload/${type}`, this.$qs.stringify({file:file,type:type}))
                    .then((res) => {
                        if(res.status == 200) {
                            if(fn !== undefined) fn.call(this, res.data)
                        }
                        else this.$jlalert.show(res.data, (res.status !== 200));
                    })
                    .catch((err) => {
                        this.$jlalert.show(err);
                    });
            this.loading = false;
        },
    },
    mounted() {
        this.$emitter.on('show_announcement', () => {
            this.modal_show = true;
        });
    },
    watch: {
        "modal_show": function(n) {
            if(n) {
                setTimeout(() => {
                    let content = this.$refs.content.$el;
                    let container = content.querySelector('.ql-editor');
                    container.innerHTML = (this.data.hasOwnProperty.call(this.data, 'data') ? this.data.data.content : '');

                    let imgbutton = document.querySelector('button.ql-img');
                    imgbutton.addEventListener('click', this.selectImage);
                }, 500);
            }
        }
    }
}
</script>

<style scoped>
.modal::after {
    background: #000;
    content: '';
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: -1;
    opacity: 0.5;
}

.modal.show {
    display: block;
    overflow: auto !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


.text-primary {
    color: var(--primary-color) !important;
}
</style>